import { Route } from '@angular/router';
import { AppUrls } from '../../../../../common/dto/app-urls';

export const CompanyRoute: Route = {
  path: AppUrls.Dashboard._.Company.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Company._.Members.relativeUrl,
      loadComponent: () => import('./company-members/company-members.component').then(_ => _.CompanyMembersComponent),
    },
    {
      path: AppUrls.Dashboard._.Company._.SiteList.relativeUrl,
      loadComponent: () => import('./sites/site-list/site-list.component').then(_ => _.SiteListComponent),
    },
    {
      path: AppUrls.Dashboard._.Company._.SiteEditor.relativeUrl,
      loadComponent: () => import('./sites/site-editor/site-editor.component').then(_ => _.SiteEditorComponent),
    },
    {
      path: AppUrls.Dashboard._.Company._.Billing.relativeUrl,
      loadComponent: () => import('./billing/billing.component').then(_ => _.BillingComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Company._.Members.relativeUrl,
    },
  ],
};
